var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"componentContainer",staticClass:"component_container h-100",staticStyle:{"overflow":"auto"},attrs:{"id":'comp-' + _vm.componentNumber + '-div'}},_vm._l((_vm.spotTable),function(dataTable,idx){return _c('div',{key:idx},[_c('div',{staticClass:"row f-row",staticStyle:{"height":"2.2rem"}},[_c('div',{staticClass:"col col-auto d-flex align-items-center"},[_c('span',{staticClass:"ml-2 mr-1",staticStyle:{"color":"var(--textactive)"}},[_vm._v(_vm._s(dataTable["name"]))])])]),(dataTable['data'].length == 0)?_c('div',{staticClass:"component_flexible"},[_c('SkeletonSpotTable',{attrs:{"showFields":_vm.showFields}})],1):_c('DataTable',{key:_vm.showFields ? 'full' : 'compact',staticClass:"p-datatable-sm overview_table",attrs:{"columnResizeMode":"expand","resizableColumns":"","scrollable":"","scrollHeight":_vm.tableHeight[idx] + 'px',"value":dataTable.data}},[_c('Column',{staticStyle:{"min-width":"120px"},attrs:{"field":"asset","header":"Asset","sortable":"","frozen":""},scopedSlots:_vm._u([{key:"body",fn:function(ref){
var data = ref.data;
return [_c('div',{staticClass:"d-flex align-items-center h-100 w-100",class:{ ovPadding: _vm.TAVisible == -1 },on:{"mouseover":function($event){return _vm.onHoverHelp(data.description, $event)},"mouseleave":function($event){return _vm.onHoverHelp(null, $event)}}},[(_vm.TAVisible > -1)?_c('ButtonView',{attrs:{"fontSize":"12","showBorder":false},on:{"btnAbort":function () { return _vm.onUserShowTAChart(data.assetType, data.asset, data.term); }}}):_vm._e(),_vm._v("\n            "+_vm._s(data.asset)+"\n            "),(data.term && data.term != '0')?_c('span',{staticClass:"ml-1"},[_vm._v("\n              ("+_vm._s(data.term)+")")]):_vm._e()],1)]}}],null,true)}),_c('Column',{staticStyle:{"min-width":"100px"},attrs:{"field":"close","header":"Last","sortable":""},scopedSlots:_vm._u([{key:"body",fn:function(ref){
var data = ref.data;
var index = ref.index;
return [_c('div',{staticClass:"d-flex align-items-center h-100 w-100 ovHighlight ovPadding",class:{
              row_up: _vm.animateUp.includes(
                idx == 0
                  ? index
                  : idx == 1
                  ? index + _vm.spotTable[0]['data'].length
                  : index +
                    _vm.spotTable[0]['data'].length +
                    _vm.spotTable[1]['data'].length
              ),
              row_down: _vm.animateDown.includes(
                idx == 0
                  ? index
                  : idx == 1
                  ? index + _vm.spotTable[0]['data'].length
                  : index +
                    _vm.spotTable[0]['data'].length +
                    _vm.spotTable[1]['data'].length
              )
            }},[(data.change !== 0)?_c('span',{class:_vm.arrowClass(data.change)}):_vm._e(),_c('span',{staticClass:"ml-1"},[_vm._v(" "+_vm._s(_vm.priceFormat(data.close)))])])]}}],null,true)}),(_vm.showFields)?_c('Column',{staticStyle:{"min-width":"100px"},attrs:{"sortable":"","field":"change","header":"Change"},scopedSlots:_vm._u([{key:"body",fn:function(ref){
            var data = ref.data;
            var index = ref.index;
return [_c('div',{staticClass:"d-flex align-items-center h-100 w-100 ovPadding",class:{
              row_up: _vm.animateUp.includes(
                idx == 0
                  ? index
                  : idx == 1
                  ? index + _vm.spotTable[0]['data'].length
                  : index +
                    _vm.spotTable[0]['data'].length +
                    _vm.spotTable[1]['data'].length
              ),
              row_down: _vm.animateDown.includes(
                idx == 0
                  ? index
                  : idx == 1
                  ? index + _vm.spotTable[0]['data'].length
                  : index +
                    _vm.spotTable[0]['data'].length +
                    _vm.spotTable[1]['data'].length
              )
            }},[_c('span',{class:{ dayUp: data.change > 0, dayDown: data.change < 0 }},[_vm._v("\n              "+_vm._s(_vm.changeFormat(data.change, data.close))+"\n            ")])])]}}],null,true)}):_vm._e(),_c('Column',{staticStyle:{"min-width":"100px"},attrs:{"field":"pct_change","header":"% Chg","sortable":""},scopedSlots:_vm._u([{key:"body",fn:function(ref){
            var data = ref.data;
            var index = ref.index;
return [_c('div',{staticClass:"d-flex align-items-center h-100 w-100 ovPadding",class:{
              row_up: _vm.animateUp.includes(
                idx == 0
                  ? index
                  : idx == 1
                  ? index + _vm.spotTable[0]['data'].length
                  : index +
                    _vm.spotTable[0]['data'].length +
                    _vm.spotTable[1]['data'].length
              ),
              row_down: _vm.animateDown.includes(
                idx == 0
                  ? index
                  : idx == 1
                  ? index + _vm.spotTable[0]['data'].length
                  : index +
                    _vm.spotTable[0]['data'].length +
                    _vm.spotTable[1]['data'].length
              )
            }},[_c('span',{class:{ dayUp: data.change > 0, dayDown: data.change < 0 }},[_vm._v("\n              "+_vm._s(_vm.percentageFormat(data.pct_change))+"\n            ")])])]}}],null,true)}),(_vm.showFields)?_c('Column',{staticStyle:{"min-width":"100px"},attrs:{"field":"pct_change_5","header":"% 5D","sortable":""},scopedSlots:_vm._u([{key:"body",fn:function(ref){
            var data = ref.data;
            var index = ref.index;
return [_c('div',{staticClass:"d-flex align-items-center h-100 w-100 ovPadding",class:{
              row_up: _vm.animateUp.includes(
                idx == 0
                  ? index
                  : idx == 1
                  ? index + _vm.spotTable[0]['data'].length
                  : index +
                    _vm.spotTable[0]['data'].length +
                    _vm.spotTable[1]['data'].length
              ),
              row_down: _vm.animateDown.includes(
                idx == 0
                  ? index
                  : idx == 1
                  ? index + _vm.spotTable[0]['data'].length
                  : index +
                    _vm.spotTable[0]['data'].length +
                    _vm.spotTable[1]['data'].length
              )
            }},[_c('span',{class:{
                dayUp: data.pct_change_5 > 0,
                dayDown: data.pct_change_5 < 0
              }},[_vm._v("\n              "+_vm._s(_vm.percentageFormat(data.pct_change_5))+"\n            ")])])]}}],null,true)}):_vm._e(),(_vm.showFields)?_c('Column',{staticStyle:{"min-width":"100px"},attrs:{"field":"pct_change_10","header":"% 10D","sortable":""},scopedSlots:_vm._u([{key:"body",fn:function(ref){
              var data = ref.data;
              var index = ref.index;
return [_c('div',{staticClass:"d-flex align-items-center h-100 w-100 ovPadding",class:{
              row_up: _vm.animateUp.includes(
                idx == 0
                  ? index
                  : idx == 1
                  ? index + _vm.spotTable[0]['data'].length
                  : index +
                    _vm.spotTable[0]['data'].length +
                    _vm.spotTable[1]['data'].length
              ),
              row_down: _vm.animateDown.includes(
                idx == 0
                  ? index
                  : idx == 1
                  ? index + _vm.spotTable[0]['data'].length
                  : index +
                    _vm.spotTable[0]['data'].length +
                    _vm.spotTable[1]['data'].length
              )
            }},[_c('span',{class:{
                dayUp: data.pct_change_10 > 0,
                dayDown: data.pct_change_10 < 0
              }},[_vm._v("\n              "+_vm._s(_vm.percentageFormat(data.pct_change_10))+"\n            ")])])]}}],null,true)}):_vm._e(),(_vm.showFields)?_c('Column',{staticStyle:{"min-width":"100px"},attrs:{"field":"pct_change_20","header":"% 20D","sortable":""},scopedSlots:_vm._u([{key:"body",fn:function(ref){
              var data = ref.data;
              var index = ref.index;
return [_c('div',{staticClass:"d-flex align-items-center h-100 w-100 ovPadding",class:{
              row_up: _vm.animateUp.includes(
                idx == 0
                  ? index
                  : idx == 1
                  ? index + _vm.spotTable[0]['data'].length
                  : index +
                    _vm.spotTable[0]['data'].length +
                    _vm.spotTable[1]['data'].length
              ),
              row_down: _vm.animateDown.includes(
                idx == 0
                  ? index
                  : idx == 1
                  ? index + _vm.spotTable[0]['data'].length
                  : index +
                    _vm.spotTable[0]['data'].length +
                    _vm.spotTable[1]['data'].length
              )
            }},[_c('span',{class:{
                dayUp: data.pct_change_20 > 0,
                dayDown: data.pct_change_20 < 0
              }},[_vm._v("\n              "+_vm._s(_vm.percentageFormat(data.pct_change_20))+"\n            ")])])]}}],null,true)}):_vm._e(),(_vm.showFields)?_c('Column',{staticStyle:{"min-width":"100px"},attrs:{"field":"open","header":"Open"},scopedSlots:_vm._u([{key:"body",fn:function(ref){
              var data = ref.data;
return [_c('div',{staticClass:"d-flex align-items-center h-100 w-100 ovPadding"},[_vm._v("\n            "+_vm._s(_vm.priceFormat(data.open))+"\n          ")])]}}],null,true)}):_vm._e(),_c('Column',{staticStyle:{"min-width":"100px"},attrs:{"field":"high","header":"High"},scopedSlots:_vm._u([{key:"body",fn:function(ref){
              var data = ref.data;
return [_c('div',{staticClass:"d-flex align-items-center h-100 w-100 ovPadding"},[_vm._v("\n            "+_vm._s(_vm.priceFormat(data.high))+"\n          ")])]}}],null,true)}),_c('Column',{staticStyle:{"min-width":"100px"},attrs:{"field":"low","header":"Low"},scopedSlots:_vm._u([{key:"body",fn:function(ref){
              var data = ref.data;
return [_c('div',{staticClass:"d-flex align-items-center h-100 w-100 ovPadding"},[_vm._v("\n            "+_vm._s(_vm.priceFormat(data.low))+"\n          ")])]}}],null,true)}),(_vm.showFields)?_c('Column',{staticStyle:{"min-width":"100px"},attrs:{"field":"prev_close","header":"Previous"},scopedSlots:_vm._u([{key:"body",fn:function(ref){
              var data = ref.data;
return [_c('div',{staticClass:"d-flex align-items-center h-100 w-100 ovPadding"},[_vm._v("\n            "+_vm._s(_vm.priceFormat(data.prev_close))+"\n          ")])]}}],null,true)}):_vm._e(),(_vm.showFields)?_c('Column',{staticStyle:{"min-width":"100px"},attrs:{"field":"observation_date","header":"Updated"},scopedSlots:_vm._u([{key:"body",fn:function(ref){
              var data = ref.data;
return [_c('div',{staticClass:"d-flex align-items-center h-100 w-100 ovPadding"},[_vm._v("\n            "+_vm._s(_vm.dateFormat(data.observation_date))+"\n          ")])]}}],null,true)}):_vm._e()],1)],1)}),0)}
var staticRenderFns = []

export { render, staticRenderFns }